<template>
        <carousel
            :per-page="1"
            :autoplay="true"
            :autoplayTimeout="6000"
            :speed="1000"
            :autoplayHoverPause="true"
            :easing="'ease'"
            :paginationEnabled="false"
            :loop="true"
        >
            <Slide
                v-for="item in items"
            >
                <HomeSlide
                    :item="item"
                    :key="item.id"
                />
            </Slide>
        </carousel>
</template>

<script>
import {Carousel, Slide} from 'vue-carousel';
import HomeSlide from './HomeSlide'
import resources from "../../../resources";

export default {
    components: {
        Carousel,
        Slide,
        HomeSlide,
    },
    data(){
        return {
            items: [],
            currentFetchId: null,
        }
    },
    mounted(){
        this.getCarousel();
    },
    methods: {
        getCarousel(){
            const fetchId = Math.random();
            this.currentFetchId = fetchId;
            resources.carousel.index({})
                .then((response) => {
                    if (fetchId !== this.currentFetchId) return;
                    this.items = response.data.data;
                }).catch(err => {
                console.log('error 48')
            });
        },
    },
    watch: {
        '$store.state.general.site_type': function(value) {
            this.currentFetchId = null;
            this.items = [];
            this.getCarousel();
        }
    }
}
</script>

<style scoped lang="scss">

</style>